/** @format */

export enum ProductReviewProsConsType {
	CON = 'con',
	PRO = 'pro'
}
